import Layout from '@/container/Full'

import PromoListView from 'Views/promo/PromoListView'
import PromoStatusView from 'Views/promo/PromoStatusView'
import PromoView from 'Views/promo/PromoRedeemView'

const routes = [
  {
    path: '/promotions',
    component: Layout,
    meta: {
      breadcrumb: 'Promotions',
      access_type: 'authorized',
    },
    children: [
      {
        path: '',
        name: 'promotions_list',
        component: PromoListView,
        meta: {
          access_type: 'authorized',
        }
      },
      {
        path: 'view/:promo_id',
        name: 'promotion_view',
        component: PromoStatusView,
        props: true,
        meta: {
          access_type: 'authorized',
          breadcrumb: routeParams => `Promotion #${routeParams.promo_id}`,
        }
      },
      {
        path: 'redeem/:promo_id',
        name: 'promo_single',
        component: PromoView,
        props: true,
        meta: {
          access_type: 'authorized',
        }
      },
    ]
  },
]

export default routes
